import question from './modules/question';
// import demo from './modules/demo';

// const routes = [...question, ...demo];
const routes = [...question];

export default routes;
